import styled from "styled-components";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import colors from "@/main/style/colors";

export const CardContainer = styled.div`
	display: flex;
	flex-direction: column;
	background-color: ${({ theme }) => theme?.white || colors.white};
	border: 0.0625rem solid ${({ theme }) => theme?.grayDarker || colors.grayDarker};
	border-radius: 0.5rem;
	padding: 1rem;
	gap: 0.75rem;
	box-shadow: 0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05);
`;

export const RowHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 0.5rem;
`;

export const Row = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const Grid2Col = styled.div`
	display: grid;
	grid-template-columns: minmax(0, 1fr) 7.5rem;
	gap: 1rem;
	width: 100%;
`;

export const TextGroup = styled.div`
	display: flex;
	flex-direction: column;
	min-width: 0;
	word-break: break-word;
`;

export const TextGroupRight = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	text-align: right;
	min-width: 5rem;
`;

export const Label = styled.span`
	font-size: 0.75rem;
	color: ${({ theme }) => theme?.neutral?.n600 || colors.neutral.n600};
	margin-bottom: 0.125rem;
`;

export const Value = styled.span`
	font-size: 0.875rem;
	color: ${({ theme }) => theme?.neutral?.n800 || colors.neutral.n800};
`;

export const ValueHighlight = styled.span`
	font-size: 0.875rem;
	font-weight: 700;
	color: ${({ theme }) => theme?.neutral?.n800 || colors.neutral.n800};
`;

export const ValueIcon = styled.div`
	display: flex;
	align-items: center;
	min-height: 1.25rem;
`;

export const SuccessIcon = styled(CheckCircleOutlineIcon)`
	&& {
		color: ${({ theme }) => theme?.figma?.system?.success || colors.figma.system.success};
		font-size: 1.25rem;
	}
`;

export const ErrorIcon = styled(CancelOutlinedIcon)`
	&& {
		color: ${({ theme }) => theme?.red || colors.red};
		font-size: 1.25rem;
	}
`;
